import { Directive, ElementRef, HostBinding, Input } from '@angular/core';

@Directive({
    selector: '[avatarTitle]',
    host: { class: 'avatar-block-title' },
})
export class AvatarBlockTitleDirective
{
    @Input() withEdit = false;

    constructor(public _el: ElementRef) {
    }

    @HostBinding('class.with-edit-button') get addEditButtonClass() {
        return this.withEdit;
    }

    get title() {
        return this._el.nativeElement.textContent;
    }
}

@Directive({
    selector: '[avatarTitleSuffix]',
    host: { class: 'avatar-block-title-suffix' },
})
export class AvatarBlockTitleSuffixDirective
{
}

@Directive({
    selector: '[avatarDescription]',
    host: { class: 'avatar-block-description' },
})
export class AvatarBlockDescriptionDirective
{
    @Input() secondary = false;

    constructor(public _el: ElementRef) {
    }

    @HostBinding('class.avatar-secondary-description') get addSecondaryDescriptionClass() {
        return this.secondary;
    }

    get description() {
        return this._el.nativeElement.textContent;
    }
}

@Directive({
    selector: '[unreadDot]',
    host: { class: 'avatar-unread-dot' },
})
export class UnreadDotDirective
{
}
